// ConfirmHost — единственный инстанс ConfirmDialog, управляемый глобальным
// confirm-стором. Монтируется один раз в __root.tsx. Любая поверхность вызывает
// `useConfirm()(...)` и получает Promise<boolean> — локальный state не нужен.
import { IconTrash } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useConfirmStore } from "@/stores/confirm";
import { ConfirmDialog } from "./confirm-dialog";

export function ConfirmHost(): React.ReactElement | null {
	const { t } = useTranslation("common");
	const open = useConfirmStore((s) => s.open);
	const options = useConfirmStore((s) => s.options);
	const resolve = useConfirmStore((s) => s.resolve);
	const cancel = useConfirmStore((s) => s.cancel);

	if (!options) return null;

	const isDestructive = options.tone === "destructive";

	return (
		<ConfirmDialog
			open={open}
			onOpenChange={(next) => {
				if (!next) cancel();
			}}
			title={options.title}
			description={options.description}
			confirmLabel={options.confirmLabel ?? t("actions.delete")}
			cancelLabel={options.cancelLabel ?? t("actions.cancel")}
			tone={options.tone ?? "default"}
			confirmIcon={isDestructive ? <IconTrash size={16} /> : undefined}
			onConfirm={resolve}
		/>
	);
}
